import { createSelector } from 'reselect';

const selectGeneral = (state) => state.general;
const selectLoading = createSelector(
	selectGeneral,
	(general) => general.loading
);

const selectApiLoadingStatus = (state, type) =>
	!!state.general.apiStatus.loading[type];

const generalSelectors = {
	selectGeneral,
	selectLoading,
	selectApiLoadingStatus,
};

export default generalSelectors;
